import { render } from "./Spinner.vue?vue&type=template&id=e2d8d4ca&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=e2d8d4ca&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d8d4ca"]])

export default __exports__